import { observer } from 'mobx-react';
import { AddressType, IAddress } from '../../../domains/common.domain';
import { AddressFormat } from '../../../domains/tenant-config';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store';

interface IProps {
  addressType: AddressType;
}

export const AddressReview = observer((props: IProps) => {
  const { t: tCommon } = useTranslation('');
  const { tenantStore, serviceAddressStore, shippingAddressStore, billingAddressStore } = useStore();
  const { addressType } = props;
  let address: IAddress = {} as IAddress;
  if (addressType === 'service') {
    address = serviceAddressStore.address;
  }
  if (addressType === 'shipping') {
    address = shippingAddressStore.address;
  }
  if (addressType === 'billing') {
    address = billingAddressStore.address;
  }
  return (
    <div>
      {tenantStore.config.addressFormat !== AddressFormat.cep && tenantStore.config.addressFormat !== AddressFormat.street && (
        <div className="d-flex">
          {addressType === 'shipping' && (
            <div className="container-readonly right-30">
              <label>{tCommon('ADDRESS.RECIPIENT')}</label>
              <span>{address.recipient.value}</span>
            </div>
          )}
          <div className="container-readonly">
            <label>{tCommon('ADDRESS.ADDRESS')}</label>
            <span>{address.address.value}</span>
          </div>
          {address.secondaryAddress.value?.trim() && (
            <div className="container-readonly left-30">
              <label>{tCommon('ADDRESS.ADDRESS_2')}</label>
              <span>{address.secondaryAddress.value}</span>
            </div>
          )}
        </div>
      )}

      {tenantStore.config.addressFormat === AddressFormat.street && (
        <div className="d-flex">
          <div className="container-readonly">
            <label>{tCommon('ADDRESS.STREET_NAME')}</label>
            <span>{address.address.value}</span>
          </div>
          <div className="container-readonly left-30">
            <label>{tCommon('ADDRESS.STREET_NUMBER')}</label>
            <span>{address.streetNumber.value}</span>
          </div>
          <div className="container-readonly left-30">
            <label>{tCommon('ADDRESS.NEIGHBORHOOD')}</label>
            <span>{address.neighborhood.value}</span>
          </div>
          <div className="container-readonly left-30">
            <label>{tCommon('ADDRESS.FLOOR')}</label>
            <span>{address.floor.value}</span>
          </div>
          <div className="container-readonly left-30">
            <label>{tCommon('ADDRESS.APARTMENT')}</label>
            <span>{address.apartment.value}</span>
          </div>
        </div>
      )}

      {tenantStore.config.addressFormat === AddressFormat.cep && (
        <div className="d-flex">
          <div className="container-readonly">
            <label>{tCommon('ADDRESS.ADDRESS')}</label>
            <span>{address.address.value}</span>
          </div>
          <div className="container-readonly left-30">
            <label>{tCommon('ADDRESS.STREET_NUMBER')}</label>
            <span>{address.streetNumber.value}</span>
          </div>
          <div className="container-readonly left-30">
            <label>{tCommon('ADDRESS.COMPLEMENT')}</label>
            <span>{address.secondaryAddress.value}</span>
          </div>
          <div className="container-readonly left-30">
            <label>{tCommon('ADDRESS.NEIGHBORHOOD')}</label>
            <span>{address.neighborhood.value}</span>
          </div>
        </div>
      )}

      <div className="d-flex">
        <div className="container-readonly">
          <label>{tCommon('ADDRESS.CITY')}</label>
          <span>{address.city.value}</span>
        </div>
        <div className="container-readonly left-30">
          <label>{tCommon('ADDRESS.STATE')}</label>
          <span>{address.state.value}</span>
        </div>
        <div className="container-readonly left-30">
          <label>{tCommon('ADDRESS.ZIP')}</label>
          <span>{address.zipCode.value}</span>
        </div>
        <div className="container-readonly left-30">
          <label>{tCommon('ADDRESS.COUNTRY')}</label>
          <span>{address.country.value}</span>
        </div>
      </div>
    </div>
  );
});
